<template>

    <div class="container md:mt-24 mt-16">
        <div class="grid grid-cols-1 pb-8 text-center">
            <SectionTitleComponent :title="'Diensten'" />
        </div>

        <div class="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 mt-8 gap-12">
            <div v-for="item in serviceStore.services" :key="item" class="group relative overflow-hidden shadow-lg rounded-lg dark:shadow-gray-700 transition  hover:cursor-pointer flex flex-col">                       
                <router-link :to="'/' + item.title.toLowerCase()">
                    <div class="relative overflow-hidden group">
                        <img :src="item.image" class="group-hover:scale-125 duration-1000 h-[200px] w-full object-cover group-hover:scale-105 transition-all duration-750" :class="item.additionalStyling" alt="">
                        <div class="absolute inset-0 h-[200px] w-full bg-zinc-700/40 opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                    </div>
                    

                    <div class="flex">
                        <div class="p-6 w-10/12">
                            <h2 class="mb-2 text-xl font-bold tracking-tight text-zinc-700 transition-all duration-500">{{ item.title }}</h2>
                            <div class="text-zinc-700" v-html="item.short_description"></div>
                        </div>

                        <div class="p-3 w-2/12 bg-amber-100 group-hover:bg-amber-300 duration-500 ease-in-out rotate-180 font-thin">
                            <p class="btn btn-link text-slate-400 group-hover:text-zinc-700 [writing-mode:vertical-lr] pt-5">
                                Meer info    | <i class="uil uil-arrow-down align-middle text-2xl inline-block mr-3 mt-2"></i>
                            </p>
                        </div>
                    </div>    
                </router-link>            
            </div>
        </div>

    </div>
</template>

<script setup>
import SectionTitleComponent from '@/components/SectionTitleComponent.vue';
import { useServiceStore } from '@/stores/service';

let serviceStore = useServiceStore();

</script>

<style lang="scss" scoped></style>